import React, { useEffect, useMemo, useRef, useState } from 'react';
import { Checkbox, Col, Row } from 'antd';
import { IroomInfo } from '@/redux/reducers/order';
import styles from './index.module.scss';

interface CheckboxCollapseItemProps {
  roomTypeName?: string;
  disabledCheckAll?: boolean;
  recordList: Array<IroomInfo>;
  value?: Array<number>;
  onSelectedChange?: (
    roomTypeName?: string,
    value?: Array<number>,
    selectedRecordList?: Array<IroomInfo>,
  ) => void;
}

const CheckboxGroup = Checkbox.Group;

// const plainOptions = ['Apple', 'Pear', 'Orange'];
// const defaultCheckedList = ['Apple', 'Orange'];

const CheckboxCollapseItem: React.FC<CheckboxCollapseItemProps> = ({
  roomTypeName = '',
  disabledCheckAll = false,
  recordList,
  value,
  onSelectedChange,
}) => {
  const [isShow, setIsShow] = useState<boolean>(false);
  const [checkedList, setCheckedList] = React.useState<Array<number>>([]);
  const [indeterminate, setIndeterminate] = React.useState(false);
  const [checkAll, setCheckAll] = React.useState(false);
  const ref = useRef<any>();

  const options = useMemo(() => {
    return recordList?.map((item) => item.roomId);
  }, [recordList]);

  const onChange = (list) => {
    setCheckedList(list);
    setIndeterminate(!!list.length && list.length < options.length);
    setCheckAll(list.length === options.length);

    const records = recordList?.filter((item) => list.includes(item.roomId));
    onSelectedChange?.(roomTypeName, list, records);
  };

  const onCheckAllChange = (e) => {
    setCheckedList(e.target.checked ? options : []);
    setIndeterminate(false);
    setCheckAll(e.target.checked);

    if (e.target.checked) {
      onSelectedChange?.(roomTypeName, options, recordList);
    } else {
      onSelectedChange?.(roomTypeName, [], []);
    }
  };

  const handleToggleShow = () => {
    if (Array.isArray(options) && options.length) {
      setIsShow(!isShow);
    }
  };

  const openState = useMemo(() => {
    if (ref.current && !isShow) {
      return 'closing';
    }
    if (!ref.current && isShow) {
      return 'opening';
    }
    return 'closing';
  }, [isShow]);

  useEffect(() => {
    ref.current = isShow;
  }, [isShow]);
  useEffect(() => {
    if (Array.isArray(value) && Array.isArray(options)) {
      setCheckedList(value);
      setIndeterminate(!!value.length && value.length < options.length);
      setCheckAll(value.length === options.length);

      if (value.length) {
        setIsShow(true);
      }
    }
  }, [value, options]);
  useEffect(() => {
    if (disabledCheckAll) {
      setIsShow(true);
    }
  }, [disabledCheckAll]);
  return (
    <div className={styles.container}>
      <div className={`${styles.title} flex-vcenter`}>
        {/* 全选按钮 */}
        <Checkbox
          className={styles.selectAll}
          indeterminate={indeterminate}
          onChange={onCheckAllChange}
          checked={checkAll}
          disabled={disabledCheckAll || !options || !options.length}
        />
        {/* 房型名称、数量、箭头 */}
        <div
          className="space-between"
          style={{ width: '100%', cursor: 'pointer' }}
          onClick={handleToggleShow}
        >
          <div className={styles.ellipsis} style={{ width: '140px' }}>
            {roomTypeName}
          </div>
          <div className="flex-center">
            <div className={styles.count}>
              {!disabledCheckAll && options && options.length
                ? `${checkedList?.length} / ${options?.length}`
                : null}
            </div>
            {options?.length ? (
              <div className={`${styles.arrowDown} ${openState ? styles[openState] : ''}`}>
                &nbsp;
              </div>
            ) : null}
          </div>
        </div>
      </div>
      {/* 房型分组下的房间 */}
      <div className={`${styles.content} ${openState ? styles[openState] : ''}`}>
        <CheckboxGroup value={checkedList} onChange={onChange} style={{ width: '100%' }}>
          {recordList?.map((item) => (
            <Row key={item.roomId}>
              <Col span={24}>
                <Checkbox value={item.roomId}>
                  <div className="space-between">
                    <div className="flex-center">
                      <div
                        className={`${item.mainStatus === 1 ? styles.bookTag : ''} ${
                          item.mainStatus === 2 ? styles.checkinTag : ''
                        }`}
                      >
                        &nbsp;
                      </div>
                      <div className={styles.roomNo}>{item.roomNo}</div>
                      {item.joinRoomNo ? (
                        <div className={styles.unite}>{item.joinRoomNo}</div>
                      ) : null}
                    </div>
                    <div className={styles.ellipsis} style={{ width: '100px', textAlign: 'right' }}>
                      {item.name}
                    </div>
                  </div>
                </Checkbox>
              </Col>
            </Row>
          ))}
        </CheckboxGroup>
      </div>
    </div>
  );
};

export default CheckboxCollapseItem;
